import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import { Subject } from 'rxjs';
import { take } from 'rxjs/internal/operators';
import * as moment from 'moment'
import { GuaranteeService } from '../services/guarantee.service';
@Component({
  selector: 'app-guarante',
  templateUrl: './guarante.component.html',
  styleUrls: ['./guarante.component.css']
})
export class GuaranteComponent implements OnInit {


  filtersActive: boolean = false;
  ammount: string;
  date: string;
  formFilters: FormGroup;
  showCollapse: boolean = true


  constructor(private formBuilder: FormBuilder, private zone: NgZone, private guaranteeService: GuaranteeService) {

  }

  ngOnInit(): void {
    this.ammount = ''
    this.date=''
    this.formFilters = this.formBuilder.group(
      {
        refNo: [
          '', Validators.required],
          dateFilter: [
            ''
          ],
          ammount: [
            ''
          ]

      }
    );


  }

  resetFilters() {


    this.filtersActive = false
    this.formFilters.controls['dateFilter'].setValue("");
    this.formFilters.controls['ammount'].setValue("");

  }
  async search() {

    let filters = {
      refNo: this.formFilters.value.refNo || '',
    }

    this.guaranteeService.getGuarantee(filters).then(res => {

      this.filtersActive = true
      let res_ammount=res.response.ammount 
      let res_date=moment(res.response.date).format("llll")
      //let res_date=moment(res.response.date).format("YYYY-MM-DD HH:mm")
      this.formFilters.controls['dateFilter'].setValue(res_date);
      // this.formFilters.controls['ammount'].setValue((res_ammount).toLocaleString('en', {
      //   style: 'currency',
      //   currency: 'LPN',
      // }));

      this.formFilters.controls['ammount'].setValue(
        new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(res_ammount)
      );
      
    })

  }



}
